import React from 'react';
export interface RankedDatum {
  label: string;
  value: number;
  /** Secondary figure shown to the right of the label, e.g. a count. */
  meta?: string;
}
interface RankedBarsProps {
  data: RankedDatum[];
  format: (value: number) => string;
  emptyLabel?: string;
}

/**
 * Horizontal ranked list. Used where the ordering is the point — which lead
 * source earns most, which employee bills most — so the longest bar reads
 * first without hunting across a legend.
 */
export function RankedBars({
  data,
  format,
  emptyLabel
}: RankedBarsProps) {
  const sorted = [...data].sort((a, b) => b.value - a.value);
  const max = Math.max(...sorted.map(d => d.value), 1);
  if (sorted.length === 0) {
    return <p className="py-6 text-sm text-stone-500" data-id="element-178" data-mp="20xj3kaehjcxi">{emptyLabel ?? 'Ingen data'}</p>;
  }
  return <ul className="space-y-3" data-id="element-179" data-mp="24zczk5dqjsrc">
      {sorted.map((datum, index) => <li key={datum.label} data-id="element-180" data-mp="24x0cxex18u7y" data-mpi={index}>
          <div className="mb-1 flex items-baseline justify-between gap-3" data-id="element-181" data-mp="29x67b2uosutq">
            <span className="min-w-0 truncate text-sm font-medium text-stone-700" data-id="element-182" data-mp="4a6ffsg7z03a">
              {datum.label}
              {datum.meta && <span className="ml-1.5 text-xs font-normal text-stone-400" data-id="element-183" data-mp="7s19lnhwoic">
                  {datum.meta}
                </span>}
            </span>
            <span className="flex-shrink-0 text-sm font-semibold tabular-nums text-stone-900" data-id="element-184" data-mp="3mgb3s4xcv4wi">
              {format(datum.value)}
            </span>
          </div>
          <div className="h-1.5 overflow-hidden rounded-full bg-stone-100" data-id="element-185" data-mp="o08g7nbxs0df">
            <div className={`h-full rounded-full ${index === 0 ? 'bg-brand-600' : 'bg-brand-300'}`} style={{
          width: `${Math.max(datum.value / max * 100, 2)}%`
        }} data-id="element-186" data-mp="izkrx9f3dxmw" />
          </div>
        </li>)}
    </ul>;
}